import React, { useState } from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";

import { makeStyles } from "@material-ui/core/styles";
import {Toolbar} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {FastForward, FastRewind} from "@material-ui/icons";

import {getDateTabs} from "../../functions/DateTabs";
import ChromeTabs from "../../controls/ChromeTabs.js";
import AlertDialog from "../../blocks/AlertDialog";
import LoadingProgress from "../../blocks/LoadingProgress";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import FuelRates from "./components/FuelRates"
import FuelStyles from "./styles/FuelStyles";

const AccessControl  = require ("../../AccessControl");

const Paths = ["/fuel", "/fuel/rates"]; 

function Fuels(props) {

  const classes = makeStyles(FuelStyles)();

  const { isAuthenticated, user } = useAuth0();
  const [fuelTabs, setFuelTabs] = useState(getDateTabs(undefined, undefined, 5,1));
  const [alertBox, setAlertBox] = useState({
    open: false,
    alertTitle: "",
    alertMessage: "",
  });

  const [state, setState] = useState({
    monthTabIndex: 5,
    loadingData: false,
    canEdit: AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage FUEL"]),
    canViewDetails: AccessControl.userHasAccess(user, ["View Detailed FUEL"]) && !AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage FUEL"])
  });

  const handleChangeMonth = (e, i) => {
    const change = { monthTabIndex: i };
    handleChange(change);
  };

  const handleChange = (change) => {
    const newState = {...change};
    if (newState) {
      setState({
        ...state,
        ...newState,
      });
    }
  };

  const handleTabSetChange = (index) => {
    setFuelTabs( getDateTabs(fuelTabs, index, 5, 1));
  }

  const render = () => {

    const currentTab = (state.monthTabIndex =
      state.monthTabIndex || 0);

    const {month, year} = fuelTabs.values[state.monthTabIndex];

    return (isAuthenticated &&
      <div
        className="Fuels"
        style={{
          backgroundColor: "#eeeeee",
          color: "#1b4481",
          fontWeight: 400,
          fontFamily: "Ubuntu,sans-serif",
          minHeight: "100vh",
        }}
      >
        <PageHeader
          parentProps={props}
          activeMenuItem="fuel"
          pageName="Fuel Rates"
          loggedInUser={user}
          logout={""}
        ></PageHeader>
        <div
          style={{
            marginLeft: 40,
            marginRight: 40,
            height: 2,
            backgroundColor: "#b7c3d4",
          }}
        ></div>
        <div style={{ height: 10 }}></div>

        <div
          className={classes.rooted}
          style={{ marginLeft: 20, marginRight: 20 }}
        >
          <Toolbar>
            <div style={{width:"50px", marginRight:10, marginLeft:10, height: 45}}>
              <IconButton
                  color="primary"
                  onClick={() => { handleTabSetChange(-1) }}
              >
                <FastRewind fontSize="large" />
              </IconButton>
            </div>
            <ChromeTabs
              style={{ alignSelf: "flex-end" }}
              tabs={fuelTabs.tabs}
              tabStyle={{
                bgColor: "#E6E8EB",
                selectedBgColor: "#ffffff",
                color: "rgba(0,0,0,0.87)",
              }}
              tabProps={{
                disableRipple: false,
              }}
              value={currentTab}
              onChange={handleChangeMonth}
            />
            <div style={{width:"50px", marginRight:10, marginLeft:10, height: 45}}>
              <IconButton
                  color="primary"
                  onClick={() => { handleTabSetChange(1) }}
              >
                <FastForward fontSize="large"/>
              </IconButton>
            </div>

          </Toolbar>
        </div>
        <div
          style={{
            marginLeft: 40,
            marginRight: 40,
            backgroundColor: "#ffffff",
          }}
        >
          <div style={{ marginLeft: 10, marginRight: 10, minHeight: `calc(100vh - ${(99+2+10+57+4+64)}px)` }}>
            <FuelRates month={month} year={year} canEdit={state.canEdit} canViewDetails={state.canViewDetails}/>
          </div>
        </div>
        <PageFooter></PageFooter>
        <AlertDialog
          open={alertBox.open}
          alertTitle={alertBox.alertTitle}
          alertMessage={alertBox.alertMessage}
          onChange={() => {
            setAlertBox({ ...alertBox, open: false });
          }}
        ></AlertDialog>
        <LoadingProgress
          open={state.loadingData}
          onChange={() => {
            setState({ ...state, loadingData: false });
          }}
        />
      </div>
    );
  };

  return render();
}

export {
  Fuels as default,
  Paths
};
